import { Cart } from '@shared/interfaces/ordering-carts/cart';
import { CartShortInfo } from '@shared/interfaces/ordering-carts/ordering-carts.interface';
import { MarkupsSettings } from '@shared/interfaces';
import { LastAddedCartItem } from './last-added-cart-item';

export interface CartState {
  cartId: string;
  cart: Cart | null;
  shortInfo: CartShortInfo | null;
  lastAddedItem: LastAddedCartItem | null;
  markupSettings: MarkupsSettings;
  loading: boolean;
  markupLoading: boolean;
}

export const initialState: CartState = {
  cartId: '',
  cart: null,
  shortInfo: null,
  lastAddedItem: null,
  markupSettings: {
    showPriceOnlyWithTradeMarkup: false,
    showPriceWithTradeMarkup: false,
    tradeMarkup: 0,
  },
  loading: false,
  markupLoading: false,
};
